// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Together_wrapper__2WpEU","content":"Together_content__ACJT_","title":"Together_title__3CiYt"};